/**
 * Cascading timeouts.
 * @param arr - Array of arrays of [timer: number, fn: Function]
 */
export function timeMachine(arr: Array<Array<any>>) {
    const [timer, fn] = arr.shift();
    setTimeout(() => {
        fn();
        if(arr.length) timeMachine(arr);
    }, timer);
}
